<div *ngIf="loadingService.spinner$ | async"
    class="d-flex flex-wrap gap-3 mb-2 position-absolute top-50 start-50 translate-middle">
    <!-- Growing spinner -->
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>